import { useEffect, useState } from "react";
import TitlePageTotvs from "../../../components/TitlePageTotvs";
import LoadingSpinner from "../../../components/LoadinSpinner";
import SubmitForm from "../../../components/SubmitForm";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col} from "react-bootstrap";
import InputGeral from "../../../components/InputGeral/Index";
import { toast } from "react-toastify";
import { ConsumoAPI_FileUpload } from "../../../../backend/ConsumoAPI";
import { LabelInput } from "../../../components/InputGeral/styles";
import UploadFiles from "../../../components/UploadFiles";
import { converteDataProtheus, ErroMsg, formatarMoeda2, RetornaUsuarioLogado, SucessoMsg, parseLocaleNumber } from "../../../contents/VariaveisGlobais";
import ConsultaSolicitacaoPagamento from "../../../../lib/json/consultas/SolicitacaoPagamento.json"
import ConsultaTipoSolicitacao from "../../../../lib/json/consultas/TipoSolicitacao.json"
import ConsultaTipoTitulo from "../../../../lib/json/consultas/TipoTitulo.json"
import ConsultaNatureza from "../../../../lib/json/consultas/Natureza.json"
import ConsultaCentroCusto from "../../../../lib/json/consultas/CentroCustoSelect.json"
import ConsultaFornecedor from "../../../../lib/json/consultas/FornecedorSelect.json"

import { addDays, addMonths, format, getDate, isWeekend, setDate } from "date-fns";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { ConsultaTotvsEmpresa } from "../../../../backend/ConsultaTotvsEmpresa";
import SelectFornecedor from "../../../components/Select/Fornecedor";
import SelectDinamico from "../../../components/SelectDinamico";
import SelectNatureza from "../../../components/Select/Natureza";
import SelectCentroCusto from "../../../components/Select/CentroCusto";

function FichaSolicitacaoPagamento(){
    const navigate = useNavigate();
    const currentDate = new Date()
    const isFormVisual = window.location.href.includes('Visualizar');
    var usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus

    const ConsultaPadraoTipo = ConsultaTipoTitulo.consulta + " AND X5_FILIAL = FILIAL(SX5) "
    const ConsultaPadraoNatureza = ConsultaNatureza.consulta + " WHERE D_E_L_E_T_ <> '*' AND ED_FILIAL = FILIAL(SED) AND ED_MSBLQL <> '1' AND ED_TIPO = '2' "
    const ConsultaPadraoCentroCusto = ConsultaCentroCusto.consulta + " WHERE CTT.D_E_L_E_T_ <> '*' AND CTT_FILIAL = FILIAL(CTT) AND CTT_CLASSE = '2' "
    const ConsultaPadraoFornecedor = ConsultaFornecedor.consulta + "WHERE A2_FILIAL = FILIAL(SA2) AND SA2.D_E_L_E_T_ <> '*' AND A2_TIPO = 'J' "

    const { idSolicitacaoPagamento, empresaFilialFinanceiro } = useParams();
    const filtraId = ( idSolicitacaoPagamento ? ` AND PS9_ID = '${idSolicitacaoPagamento}'` : '' );
	const filtraUser = ( usuarioLogado?.solicitacaoPagamento !== false ? " AND PS9_DESCR = '" + usuarioProtheus.value + "' AND PS9_DESCR != '' " : " " );
	const consultaDefault  = ConsultaSolicitacaoPagamento.consulta + filtraId + filtraUser;

    const [carregar, setCarregar] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);
        
    const [consultaTipo, setConsultaTipo] = useState(ConsultaPadraoTipo);
    const [consultaNatureza, setConsultaNatureza] = useState(ConsultaPadraoNatureza);
    const [consultaCentroCusto, setConsultaCentroCusto] = useState(ConsultaPadraoCentroCusto);
    const [digitaNumeroTitulo, setDigitaNumeroTitulo] = useState(true);

    const [empresaFilial, setEmpresaFilial] = useState(empresaFilialFinanceiro);
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState(empresaFilialFinanceiro);
    const [campoNumero, setCampoNumero] = useState();
    const [campoFornecedor, setCampoFornecedor] = useState();
    const [campoDataEmissao, setCampoDataEmissao] = useState(format(currentDate, 'yyyy-MM-dd'));
    const [campoDataVencto, setCampoDataVencto] = useState();
    const [campoTipoSolicitacao, setCampoTipoSolicitacao] = useState();
    const [campoPrefixo, setCampoPrefixo] = useState();
    const [campoNumeroTitulo, setCampoNumeroTitulo] = useState();
    const [campoTipoTitulo, setTipoTitulo] = useState()
    const [campoValorTitulo, setCampoValorTitulo] = useState(0)
    const [campoNatureza, setCampoNatureza] = useState()
    const [campoCentroCusto, setCampoCentroCusto] = useState()
    
    const [campoAnexos, setCampoAnexos] = useState("");
    
    useEffect( () => {
        const fetchData = async() => {
            if (idSolicitacaoPagamento){
                const retornaAcesso = await loadSolicitacaoPagamento()

                if (!retornaAcesso) {
                    ErroMsg("Não encontrado ou Usuário não tem Permissão de Acesso!");
                    navigate('/financeiro/SolicitacaoPagamento');
                }
            }
        }

        const dataVencto = handleDataVencto()
        setCampoDataVencto(format(dataVencto, 'yyyy-MM-dd'));
        
        fetchData()
    }, []);

    const loadSolicitacaoPagamento = async() => {
        setCarregar(true);
        let lRetorno = true;
        
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaSolicitacaoPagamento.tabelas, empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) );
                
        if (retConsulta.data && retConsulta.data.length > 0){
            const { PSC_DESC, CTT_DESC01, ED_DESCRIC, PS9_STATUS, PS9_ID, PS9_FORNEC, PS9_LOJA, PS9_EMISSA, PS9_VENCTO, PS9_TIPOSL, PS9_PRFTIT, PS9_NUMTIT, PS9_TIPO, PS9_VALOR, PS9_NATUR, PS9_CC, PS9_ANEXOS, A2_NOME, A2_CGC, X5_DESCRI} = retConsulta.data[0]
            
            setCampoTipoSolicitacao({value: PS9_TIPOSL, label: PS9_TIPOSL + ' - ' + PSC_DESC })
            setCampoNumero(PS9_ID)            
            setCampoFornecedor({value: PS9_FORNEC + '' + PS9_LOJA, label: PS9_FORNEC + '/' + PS9_LOJA + ' - ' + A2_NOME.trim() + '(' + A2_CGC.trim() + ')'})
            setCampoDataEmissao(converteDataProtheus(PS9_EMISSA))
            setCampoDataVencto(converteDataProtheus(PS9_VENCTO))
            setCampoPrefixo(PS9_PRFTIT)
            setCampoNumeroTitulo(PS9_NUMTIT)
            setTipoTitulo({value: PS9_TIPO, label: PS9_TIPO + ' - ' + X5_DESCRI })
            setCampoValorTitulo(formatarMoeda2(parseFloat(PS9_VALOR),2))
            setCampoNatureza({value: PS9_NATUR, label: PS9_NATUR + ' - ' + ED_DESCRIC })
            setCampoCentroCusto({value: PS9_CC, label: PS9_CC + ' - ' + CTT_DESC01 })

            try {
                const anexoSP = JSON.parse(PS9_ANEXOS);
                
                setCampoAnexos(anexoSP);
            } catch (erro) {
                console.log('Erro ao converter campo de Anexo' + erro);
            }

            if (PS9_STATUS === 'T'){
                setDisabledForm(true);
            }
        }else{
            lRetorno = false;
        }

        setCarregar(false);

        return lRetorno
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)

        usuarioLogado = RetornaUsuarioLogado(true, e.value)     
    }

    const handleSalvar = async() => {
		let oRetorno;
		
		
		if (!campoTipoSolicitacao) {
			toast.warning('O preenchimento do Tipo de Solicitação é obrigatório.');
			return false; //  AQUI
		}

		if (!campoDataEmissao) {
			toast.warning('O preenchimento da Data de Emissão é obrigatório.');
			return false;
		}

		if (!campoPrefixo) {
			toast.warning('O preenchimento do Prefixo é obrigatório.');
			return false;
		}

		if (!campoTipoTitulo) {
			toast.warning('O preenchimento do Tipo de Título é obrigatório.');
			return false;
		}

		if (!campoNumeroTitulo) {
			toast.warning('O prenchimento do Número do Título é obrigatório.');
			return false;
		}

		if (!campoFornecedor) {
			toast.warning('A seleção do Fornecedor é obrigatório.');
			return false;
		}

		if (!campoCentroCusto) {
			toast.warning('A seleção do Centro de Custo é obrigatório.');
			return false;
		}

		if (!campoNatureza) {
			toast.warning('A seleção da Natureza é obrigatória.');
			return false;
		}
		if (!campoAnexos || campoAnexos.length === 0) {
			toast.warning('O prenchimento do campo de Anexo é obrigatório.');
			return false;
		}

		 const valorTitulo = parseLocaleNumber(
			(campoValorTitulo || '0')
		);
		
		if (valorTitulo <= 0) {
			toast.warning('O Valor do Título deve ser superior a Zero.');
			return false;
		}

		const cJSONSalvar = {
		    PS9_DESCR: usuarioProtheus.value,
		    PS9_TIPOSL: campoTipoSolicitacao,
		    PS9_ID: campoNumero,
		    PS9_FORNEC: campoFornecedor.value.substr(0,6),
		    PS9_LOJA: campoFornecedor.value.substr(6,4),
		    PS9_EMISSA: campoDataEmissao,
		    PS9_VENCTO: campoDataVencto,
		    PS9_PRFTIT: campoPrefixo,
		    PS9_NUMTIT: campoNumeroTitulo,
		    PS9_TIPO: campoTipoTitulo,
		    PS9_VALOR: campoValorTitulo,
		    PS9_NATUR: campoNatureza,
		    PS9_CC: campoCentroCusto,
		    PS9_ANEXOS: campoAnexos ? JSON.stringify(campoAnexos) : "",
		}

        setCarregar(true)

        if (idSolicitacaoPagamento){
            oRetorno = await ConsumoTOTVS_POST('ALTERARSOLICITACAOPAGAMENTO', cJSONSalvar, empresaFilial)
        }else{
            oRetorno = await ConsumoTOTVS_POST('NOVASOLICITACAOPAGAMENTO', cJSONSalvar, empresaFilial)
        }
        
        setCarregar(false)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description);
        }else{
            ErroMsg(oRetorno.description);
			return false;
		}


        return true
    }

    const handleAddFiles = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];

        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data.map(file => file);
            const filesUpload = [...campoAnexos, ...newFiles]
            setCampoAnexos(filesUpload)

            return filesUpload;
        }
    }

    const handleDelFiles = (fileDelete) => {
        const updatedFiles = [...campoAnexos];
        updatedFiles.splice(fileDelete, 1);

        setCampoAnexos(updatedFiles)
        return updatedFiles;
    }

    const handleBlurNumeroTitulo = () => {
        const value = campoNumeroTitulo.trim().padStart(9, '0');

        setCampoNumeroTitulo(value);
    }

    useEffect( () => {
        if (campoTipoSolicitacao?.origem){
            const { PSC_CC, PSC_NATUR, PSC_TIPO, PSC_PREFIX, PSC_FORNEC, PSC_NUMTIT } = campoTipoSolicitacao.origem
            
            const cConsultaTipo = ConsultaPadraoTipo + ( PSC_TIPO && PSC_TIPO.trim() ? " AND X5_CHAVE IN ('" + PSC_TIPO.replace(';', "','") + "')" : "" )
            const cConsultaNatureza = ConsultaPadraoNatureza + ( PSC_NATUR && PSC_NATUR.trim() ? " AND ED_CODIGO IN ('" + PSC_NATUR.replace(';', "','") + "')" : "" )            
            const cConsultaCentroCusto = ConsultaPadraoCentroCusto + ( PSC_CC && PSC_CC.trim() ? "AND CTT_CUSTO IN ('" + PSC_CC.replace(';', "','") + "')" : "" )

            setConsultaTipo(cConsultaTipo)
            setConsultaNatureza(cConsultaNatureza)
            setConsultaCentroCusto(cConsultaCentroCusto)

            setCampoPrefixo(PSC_PREFIX || "")
            setDigitaNumeroTitulo( ( (PSC_NUMTIT || "S") === "S" ? true : false ) )
        }
    },[campoTipoSolicitacao])

    const handleDataVencto = () => {
        const vencimentoDia = parseInt(window._env_?.REACT_APP_VENCIMENTO_PJ) || 18;
        const hoje = new Date();

        // Verifica se o vencimento deste mês já passou
        const vencimentoEsteMes = setDate(new Date(), vencimentoDia);
        let dataBase = getDate(hoje) > vencimentoDia ? addMonths(vencimentoEsteMes, 1) : vencimentoEsteMes;

        // Se a data cair em final de semana, avança até o próximo dia útil
        while (isWeekend(dataBase)) {
            dataBase = addDays(dataBase, 1);
        }

        return dataBase;
    };

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text="Solicitação de Pagamento" 
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial && (
                <>
                    <Row>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Numero"
                                placeholder="Numero"
                                tipo="text"
                                value={campoNumero}
                                onChange={(e) => setCampoNumero(e)}
                                disabled={true}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <SelectDinamico 
                                label={"Tipo de Solicitação"}
                                disabled={disabledForm}
                                EmpresaLogada={empresaFilial}
                                consulta={ConsultaTipoSolicitacao.consulta}
                                tabela={ConsultaTipoSolicitacao.tabelas}
                                cText="PSC_ID + ' - ' + item.PSC_DESC"
                                cValue="PSC_ID"
                                campoValue={campoTipoSolicitacao}
                                onchange={setCampoTipoSolicitacao}
                                returnOrigem={true}
                                showNoFilter={true}
                            />
                        </Col>
                        <Col md="5" xs="12">
                            <SelectFornecedor
                                campoFornecedor={campoFornecedor}
                                changeFornecedor={setCampoFornecedor}
                                queryFornecedor={ConsultaPadraoFornecedor}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                                returnOriginal={true}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Data Emissão"
                                tipo='date'
                                value={campoDataEmissao}  // Use detail.cargo instead of campoEmail
                                onChange={(e) => setCampoDataEmissao(e.target.value)}
                                disabled={disabledForm}
                            />
                        </Col>                        
                    </Row>
                    <Row>                        
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Prefixo"
                                placeholder="Prefixo"
                                tipo="text"
                                value={campoPrefixo}
                                onChange={(e) => setCampoPrefixo(e.target.value)}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Número Título"
                                placeholder="Número Título"
                                tipo="text"
                                value={campoNumeroTitulo}
                                onChange={(e) => setCampoNumeroTitulo(e.target.value)}
                                handleBlur={handleBlurNumeroTitulo}
                                disabled={disabledForm && !digitaNumeroTitulo}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <SelectDinamico
                                label={"Tipo Título"}
                                disabled={disabledForm}
                                EmpresaLogada={empresaFilial}
                                consulta={consultaTipo}
                                tabela={ConsultaTipoTitulo.tabelas}
                                cText="X5_CHAVE + ' - ' + item.X5_DESCRI"
                                cValue="X5_CHAVE"
                                campoValue={campoTipoTitulo}
                                onchange={(e) => setTipoTitulo(e)}
                                returnOrigem={false}
                                selectOptionUnique={true}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <InputGeral
                                label="Valor Título"
                                placeholder="Valor Título"
                                tipo="monetario"
                                value={campoValorTitulo}
                                disabled={disabledForm}
                                onChange={(e) => setCampoValorTitulo(e.target.value)}
                                decimal={2}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Data Vencimento"
                                tipo='date'
                                value={campoDataVencto}  // Use detail.cargo instead of campoEmail
                                onChange={(e) => setCampoDataVencto(e.target.value)}
                                disabled={true}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6" xs="12">
                            <SelectNatureza
                                campoNatureza={campoNatureza}
                                changeNatureza={setCampoNatureza}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                                queryNatureza={consultaNatureza}                                
                                selectOptionUnique={true}
                            />
                        </Col>
                        <Col md="6" xs="12">
                            <SelectCentroCusto
                                campoCentroCusto={campoCentroCusto}
                                changeCentroCusto={setCampoCentroCusto}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                                queryCentroCusto={consultaCentroCusto}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <LabelInput>Anexos</LabelInput>
                            <UploadFiles 
                                onDropEvent={handleAddFiles}
                                onDeleteEvent={handleDelFiles}
                                value={campoAnexos}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                </>
            )}
            
            <SubmitForm 
                onSave={ disabledForm ? null : handleSalvar}
                onCancel={ disabledForm ? null : 'handleVoltar'}
                onVoltar={ disabledForm ? 'handleVoltar' : null}
            />
            
        </>
    );
}

export default FichaSolicitacaoPagamento;